import { FC } from 'react'
import cn from 'classnames'

import useMessenger from '@/hooks/useMessenger'
import { StoreContext } from '..'
import { StoreContextType } from '@/context/types'

import { USER_TYPES } from '@/context/constants'

export interface SendToChipProps {
  type: string
  displayName: string | null
  context?: React.Context<StoreContextType | null>
}

const SendToChip: FC<SendToChipProps> = ({
  type,
  displayName,
  context = StoreContext,
}) => {
  const { getSendTo, setSendTo } = useMessenger(context)

  const isActive = getSendTo()[type]

  const handleOnClick = () => {
    if (type === 'poplar') return null

    let sendTo = getSendTo()
    if (type === USER_TYPES.OWNER) {
      sendTo[USER_TYPES.RENTER] = false
    }

    if (type === USER_TYPES.RENTER) {
      sendTo[USER_TYPES.OWNER] = false
    }

    sendTo[type] = !isActive
    setSendTo(sendTo)
  }

  if (!displayName) {
    return null
  }

  return (
    <div
      className={cn(
        {
          'send-to-btn btn-primary': isActive,
        },
        {
          'send-to-btn btn-secondary': !isActive,
        },
      )}
      onClick={handleOnClick}
    >
      {displayName}
    </div>
  )
}

export default SendToChip
